import React from "react";
import "../button/button.scss";
import { IoIosArrowRoundForward } from "react-icons/io";

const Button = ({ text, onClick }) => {
  return (
    <div className="button-wrap">
      <button type="button" className="talk-button" onClick={onClick}>
        <span className="text">{text}</span>
        <span className="icon-circle">
          <IoIosArrowRoundForward className="arrow-icon arrow-default" />
          <IoIosArrowRoundForward className="arrow-icon arrow-hover" />
        </span>
      </button>
    </div>
  );
};

export default Button;
